/* ============================================================================
   Enganche con la tienda real: variantes de Shopify y formulario de Releasit.
   Se carga DESPUÉS de nz.js. Es el mismo mecanismo probado en la clorofila.
   ========================================================================== */
(function () {
  'use strict';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));

  /* ------------------------------------------- el pack elegido es la variante */
  const campo = $('[data-nz-variante]');
  const forma = $('#nz-form') || (campo && campo.closest('form'));
  const packs = $('[data-nz-packs]');
  const modoCantidad = packs && packs.dataset.modo === 'cantidad';

  document.addEventListener('nz:pack', () => {
    if (modoCantidad) return; // con una sola variante no hay nada que cambiar
    const activo = $('.nz-pack.es-activo');
    if (!activo || !campo) return;
    const id = activo.dataset.variante;
    if (!id || campo.value === id) return;
    campo.value = id;
    campo.dispatchEvent(new Event('change', { bubbles: true }));
    if (forma) forma.dispatchEvent(new Event('change', { bubbles: true }));
    // Releasit lee la variante de la URL: hay que mantenerla al día.
    try {
      const u = new URL(location.href);
      u.searchParams.set('variant', id);
      history.replaceState(history.state, '', u);
    } catch (e) {}
  });

  /* ------------------------------------------------- packs por cantidad */
  /* Unido a Dropi, el producto tiene UNA sola variante: Dropi despacha por
     cantidad, así que "2 + 1 de regalo" tiene que llegarle como cantidad 3.
     El precio del pack lo pone la oferta por cantidad de Releasit; aquí solo
     se marca sola, al abrir el formulario, la oferta que calza con el pack
     elegido en la página (radios con id fijo quantity_offer_0/1/2). */
  if (modoCantidad) {
    const idProducto = String(packs.dataset.producto || '');
    const elegido = () => +(($('.nz-pack.es-activo', packs) || {}).dataset || {}).pack || 1;
    const indiceDeOferta = cantidad => {
      const grupos = window._RSI_COD_FORM_QUANTIY_OFFERS || [];
      // Primero la oferta de ESTE producto; hay otras (clorofila, Peel Shot).
      const propio = grupos.find(g => (g.pIds || []).map(String).includes(idProducto) && g.isActive !== false);
      const lista = propio ? [propio] : grupos;
      for (const g of lista) {
        const i = (g.offers || []).findIndex(o => +o.qty === cantidad);
        if (i >= 0) return i;
      }
      return -1;
    };

    // Velo: marcar la oferta obliga a Releasit a recalcular y el total pasa ~2 s
    // por cifras que no son. Se tapa desde el toque del botón.
    let velo = null, tope = null;
    const quitarVelo = () => { clearTimeout(tope); if (velo) velo.remove(); velo = null; };
    const ponerVelo = () => {
      if (velo) return;
      velo = document.createElement('div');
      velo.className = 'nz-velo';
      velo.setAttribute('role', 'status');
      velo.innerHTML = '<span class="nz-velo__giro"></span><span class="nz-velo__txt">Preparando tu pedido…</span>';
      document.body.appendChild(velo);
      tope = setTimeout(quitarVelo, 7000);
    };
    document.addEventListener('click', e => {
      const t = e.target && e.target.closest && e.target.closest('[data-nz-comprar], [id^="rsi_buy_now_button"]');
      if (t && indiceDeOferta(elegido()) > 0) ponerVelo();
    }, true);

    let pedida = false;
    setInterval(() => {
      if (!document.getElementById('quantity_offer_0')) { pedida = false; return; } // formulario cerrado
      const i = indiceDeOferta(elegido());
      if (i < 0) { quitarVelo(); return; }
      const radio = document.getElementById('quantity_offer_' + i);
      if (!radio) return;
      if (radio.checked) { quitarVelo(); pedida = true; return; }
      if (pedida) return;
      pedida = true;
      ponerVelo();
      radio.click();
    }, 150);
  }

  /* --------------------------------------------------- el botón de Releasit */
  /* Releasit mete su propio botón dentro del <form>. Mientras no haya cargado,
     el nuestro queda de respaldo; cuando aparece, el CSS esconde el nuestro y
     este puente hace que tocar la barra fija abra el suyo. */
  const suyo = () => $$('[id^="rsi_buy_now_button"]').find(b => b.offsetWidth > 0) || null;
  $$('[data-nz-comprar]').forEach(b => b.addEventListener('click', e => {
    const r = suyo();
    if (r && r !== b) { e.preventDefault(); r.click(); return; }
    // Sin Releasit, el botón de la barra lleva a la ficha para elegir pack.
    if (b.hasAttribute('data-nz-barra-btn')) {
      e.preventDefault();
      const destino = $('#nz-packs');
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }));
})();
